<template v-if="elements.length > 1">
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        class="mr-4 mb-0"
        v-on="on"
        @click="!loading && elements.splice(idx, 1)"
      >
        mdi-delete-outline
      </v-icon>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    idx: {
      type: Number,
      required: true,
    },
    elements: {
      type: Array,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style></style>
